export const MAX_DOGS_THRESHOLD = 6
export const DOGS = 'dogs'
export const DOG = 'dog'
export const NAMES_ARE = 'names are'
export const NAME_IS = 'name is'
export const MIN_WEIGHT_THRESHOLD = 10
export const MAX_WEIGHT_THRESHOLD = 200

export const ageContextOptions = [
	{
		label: 'Years',
		value: 'years'
	},
	{
		label: 'Months',
		value: 'months'
	},
	{
		label: 'Weeks',
		value: 'weeks'
	},
	{
		label: 'Days',
		value: 'days'
	}
]

export const genderOptions = [
	{
		label: 'He',
		value: 'male'
	},
	{
		label: 'She',
		value: 'female'
	}
]

export const alterationStatusOptions = [
	{
		label: 'Is',
		value: 'altered'
	},
	{
		label: 'Is Not',
		value: 'intact'
	}
]

export const tempermentOptions = [
	{
		label: 'Cutest',
		value: 'cutest'
	},
	{
		label: 'Best',
		value: 'best'
	},
	{
		label: 'Smartest',
		value: 'smartest'
	},
	{
		label: 'Most Energetic',
		value: 'most energetic'
	},
	{
		label: 'Most Loving',
		value: 'most loving'
	},
	{
		label: 'Most Loyal',
		value: 'most loyal'
	},
	{
		label: 'Most Playful',
		value: 'most playful'
	}
]

export const activityOptions = [
	{
		label: 'Couch Potato',
		value: 'couch-potato'
		// image: '/img/activity-level-not-active.webp'
	},
	{
		label: 'Daily Walks / Play',
		value: 'daily-walks-play'
		// image: '/img/activity-level-active.webp'
	},
	{
		label: 'Super Pup',
		value: 'super-pup'
		// image: '/img/activity-level-pro-athlete.webp'
	}
]

export const bodyConditionOptions = [
	{
		label: 'Too Skinny',
		value: 'too-skinny'
		// image: '/img/body-condition-too-skinny.webp'
	},
	{
		label: 'Just Right',
		value: 'just-right'
		// image: '/img/body-condition-just-right.webp'
	},
	{
		label: 'Rounded',
		value: 'rounded'
		// image: '/img/body-condition-rounded.webp'
	},
	{
		label: 'Chunky',
		value: 'chunky'
		// image: '/img/body-condition-chunky.webp'
	}
]

export const mealtimeOptions = [
	{
		label: 'Very Picky',
		value: 'very-picky'
		// image: '/img/eating-style-very-picky.webp'
	},
	{
		label: 'Can be Picky',
		value: 'can-be-picky'
		// image: '/img/eating-style-can-be-picky.webp'
	},
	{
		label: 'Good Eater',
		value: 'good-eater'
		// image: '/img/eating-style-good-eater.webp'
	},
	{
		label: 'Will eat anything',
		value: 'will-eat-anything'
		// image: '/img/eating-style-will-eat-anything.webp'
	}
]

export const foodTypeOptions = [
	{
		label: 'Dry Food',
		value: 'dry-food'
	},
	{
		label: 'Wet Food',
		value: 'wet-food'
	},
	{
		label: 'Raw Food',
		value: 'raw-food'
	},
	{
		label: 'Fresh Food',
		value: 'fresh-food'
	},
	{
		label: 'Home made food',
		value: 'home-cooked'
	},
	{
		label: 'Dehydrated',
		value: 'dehydrated'
	}
]

export const treatsOptions = [
	{
		label: 'Some',
		value: 'some'
	},
	{
		label: 'No',
		value: 'no'
	},
	{
		label: 'A lot of',
		value: 'a-lot-of'
	}
]
